document.querySelectorAll('.product-reels-swiper').forEach(function (swiperEl) {
  initProductReels(swiperEl);
});

function initProductReels(swiperEl) {
  var cartCache = null;
  var realCount = swiperEl.querySelectorAll('.reel-item').length;

  function applySlideWidths() {
    var cw  = swiperEl.clientWidth;
    var vw  = window.innerWidth;
    var rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
    var w;
    if (vw >= 1200) {
      w = cw * 0.19 - 1.3 * rem;
    } else if (vw >= 990) {
      w = cw / 3 - 14;
    } else if (vw >= 750) {
      w = cw / 2 - 9;
    } else {
      w = cw * 0.60;
    }
    swiperEl.querySelectorAll('.swiper-slide').forEach(function (slide) {
      slide.style.width = Math.round(w) + 'px';
    });
  }

  // Attach pause / mute listeners directly on every button in a slide.
  // Direct listeners (not delegation) ensure the browser treats video.play()
  // as a real user gesture so audio unlocks correctly.
  function initSlideControls(slide) {
    if (slide._ctrlInit) return;
    slide._ctrlInit = true;

    var video    = slide.querySelector('[data-reel-video]');
    var pauseBtn = slide.querySelector('.pause-btn');
    var muteBtn  = slide.querySelector('.mute-btn');

    if (!video) return;

    if (pauseBtn) {
      pauseBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (video.paused) {
          video.play().catch(function () {});
          pauseBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="white"><rect x="6" y="4" width="4" height="16" rx="1"/><rect x="14" y="4" width="4" height="16" rx="1"/></svg>';
        } else {
          video.pause();
          pauseBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="white"><polygon points="5 3 19 12 5 21 5 3"/></svg>';
        }
      });
    }

    if (muteBtn) {
      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        var nowMuted = !video.muted;
        video.muted = nowMuted;
        if (!nowMuted) {
          video.removeAttribute('muted');
          video.volume = 1;
        }
        // play() called directly from this click — browser grants audio
        video.play().catch(function () {});
        muteBtn.querySelector('.muted-icon').style.display   = nowMuted ? 'block' : 'none';
        muteBtn.querySelector('.unmuted-icon').style.display = nowMuted ? 'none'  : 'block';
      });
    }

    video.addEventListener('click', function (e) {
      if (e.target.closest('.video-controls') || e.target.closest('.reel-product-card')) return;
      if (video.paused) {
        video.play().catch(function () {});
        if (pauseBtn) pauseBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="white"><rect x="6" y="4" width="4" height="16" rx="1"/><rect x="14" y="4" width="4" height="16" rx="1"/></svg>';
      } else {
        video.pause();
        if (pauseBtn) pauseBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="white"><polygon points="5 3 19 12 5 21 5 3"/></svg>';
      }
    });
  }

  applySlideWidths();

  var swiper = new Swiper(swiperEl, {
    loop: true,
    initialSlide: Math.floor(realCount / 2),
    centeredSlides: true,
    grabCursor: true,
    slidesPerView: 'auto',
    spaceBetween: 20,
    keyboard: { enabled: true },
    breakpoints: {
      750: { spaceBetween: 18 }
    },
    on: {
      afterInit: function (sw) {
        applySlideWidths();
        sw.update();
        // Init controls on ALL slides including Swiper loop clones
        sw.slides.forEach(function (slide) { initSlideControls(slide); });
        var video = sw.slides[sw.activeIndex] && sw.slides[sw.activeIndex].querySelector('[data-reel-video]');
        if (video) video.play().catch(function () {});
      },
      resize: function () {
        applySlideWidths();
      },
      slideChange: function (sw) {
        sw.el.querySelectorAll('[data-reel-video]').forEach(function (v) { v.pause(); });
      },
      slideChangeTransitionEnd: function (sw) {
        var activeSlide = sw.slides[sw.activeIndex];
        var video = activeSlide && activeSlide.querySelector('[data-reel-video]');
        if (video) {
          video.muted = true;
          video.currentTime = 0;
          video.play().catch(function () {});
          var muteBtn = activeSlide.querySelector('.mute-btn');
          if (muteBtn) {
            muteBtn.querySelector('.muted-icon').style.display   = 'block';
            muteBtn.querySelector('.unmuted-icon').style.display = 'none';
          }
        }
      }
    }
  });

  // ── Add to cart (capture phase so Swiper doesn't block it) ─────────────────

  swiperEl.addEventListener('click', async function (e) {
    var addBtn = e.target.closest('.reel-atc-button');
    if (!addBtn) return;

    e.preventDefault();
    e.stopPropagation();

    var form = addBtn.closest('.reel-product-form');
    if (!form) return;

    var selectWrap  = form.querySelector('.reel-variant-select');
    var selectInput = form.querySelector("select[name='id']");
    var hiddenInput = form.querySelector("input[name='id']");

    if (selectInput && selectWrap && selectWrap.classList.contains('is-hidden')) {
      selectWrap.classList.remove('is-hidden');
      selectInput.focus();
      return;
    }

    var variantId = (selectInput && selectInput.value) || (hiddenInput && hiddenInput.value);
    if (!variantId) { alert('Please select a variant first'); return; }

    addBtn.disabled = true;
    var originalText = addBtn.innerHTML;
    addBtn.innerHTML = 'Adding...';

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!res.ok) throw new Error(await res.text());

      addBtn.innerHTML = '✓ Added!';
      addBtn.classList.add('added');
      setTimeout(function () {
        addBtn.innerHTML = originalText;
        addBtn.disabled = false;
        addBtn.classList.remove('added');
        if (selectWrap && !selectWrap.classList.contains('is-hidden')) {
          selectWrap.classList.add('is-hidden');
        }
      }, 2000);

      showCartToast('Added to Cart!');
      var cart = await fetchCart(true);
      updateCartBubble(cart.item_count);
      if (window.Shopflo && typeof window.Shopflo.refreshCart === 'function') window.Shopflo.refreshCart();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));

    } catch (err) {
      console.error('[REEL ATC]', err);
      addBtn.disabled = false;
      addBtn.innerHTML = originalText;
      alert('Failed to add to cart. Please try again.');
    }
  }, true);

  swiperEl.addEventListener('change', async function (e) {
    var selectInput = e.target.closest('select[name="id"]');
    if (!selectInput || !selectInput.hasAttribute('data-reel-variant-select')) return;
    var form       = selectInput.closest('.reel-product-form');
    var addBtn     = form && form.querySelector('.reel-atc-button');
    var selectWrap = form && form.querySelector('.reel-variant-select');
    if (selectWrap && !selectWrap.classList.contains('is-hidden') && addBtn) addBtn.click();
  });

  // ── Cart helpers ────────────────────────────────────────────────────────────

  async function fetchCart(force) {
    if (cartCache && !force) return cartCache;
    try {
      var res = await fetch('/cart.js');
      if (!res.ok) throw new Error('cart fetch failed');
      cartCache = await res.json();
      return cartCache;
    } catch (e) {
      return { items: [], item_count: 0, total_price: 0 };
    }
  }

  function updateCartBubble(count) {
    var bubble = document.querySelector('.header__icon--cart .cart-count-bubble');
    if (bubble) {
      bubble.textContent = count;
    } else {
      var icon = document.querySelector('.header__icon--cart');
      if (icon) {
        var b = document.createElement('div');
        b.className = 'cart-count-bubble flo-cart-icon-bubble';
        b.textContent = count;
        icon.appendChild(b);
      }
    }
  }

  function showCartToast(message) {
    var toast = document.querySelector('.cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cart-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message || 'Added to Cart!';
    toast.classList.remove('show');
    void toast.offsetWidth;
    toast.classList.add('show');
    setTimeout(function () {
      toast.classList.remove('show');
      setTimeout(function () { if (toast.parentNode) toast.remove(); }, 300);
    }, 2500);
  }

  fetchCart().then(function (cart) { updateCartBubble(cart.item_count); });
}
